import { defineMessages } from "react-intl";
import { defaultCrudMessages } from "../shared/crud/simple-crud";

const analyticsConfigurationMessages = defineMessages({
  entityName: {
    id: "analyticsConfiguration.entityName",
    defaultMessage: "Analytics configuration",
  },
  analyticsConfigurationWarning: {
    id: "analyticsConfiguration.warning",
    defaultMessage:
      "Injecting code through GTM can damage or render unusable the Booking engine, please be careful and only use verified and trusted code.",
  },
  gtmCodesPlaceholder: {
    id: "analyticsConfiguration.gtmCodes.placeholder",
    defaultMessage: "code1,code2,code3...",
  },
  gtmCodesLabel: {
    id: "analyticsConfiguration.gtmCodes.label",
    defaultMessage: "GTM Codes",
  },
  gtmCodesHelpText: {
    id: "analyticsConfiguration.gtmCodes.gtmCodesHelpText",
    defaultMessage:
      "This field is optional and can be used if custom scripts must be inserted in the booking engine through Google Tag Manager",
  },
});

export const messages = {
  ...defaultCrudMessages,
  ...analyticsConfigurationMessages,
};
